import React from 'react';
import Login from '../components/login/login';

export default function LoginPage() {
  // Keep the same UI but explicitly pass the realm = "user"
  return <Login realm="user" />;
}
